import { Router, Route } from 'wouter'
import HomePage from './pages/HomePage'
import GetInTouchPage from './pages/GetInTouchPage'
import DirectorVisionPage from './pages/DirectorVisionPage'
import MediaPage from './pages/MediaPage'

function App() {
  return (
    <Router base="/the-monsters-we-make">
      <Route path="/" component={HomePage} />
      <Route path="/director-vision" component={DirectorVisionPage} />
      <Route path="/media" component={MediaPage} />
      <Route path="/get-in-touch" component={GetInTouchPage} />
    </Router>
  )
}

export default App
